const DAY_MS = 86_400_000;

const ROLLING: Record<string, number> = { '7d': 7, '30d': 30, '90d': 90, '365d': 365 };

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

const startOfDay = (date: Date): number => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

const dayFrom = (iso: string): number | null => {
    if (!ISO_DAY.test(iso)) return null;
    const [year, month, day] = iso.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.getMonth() === month - 1 ? date.getTime() : null;
};

export function dateWindowMatch(window: string, iso: string | null | undefined, now: Date = new Date()): boolean {
    if (!window) return true;
    if (!iso) return false;
    const at = new Date(iso).getTime();
    if (Number.isNaN(at)) return false;

    if (window.startsWith('range:')) {
        const [, from = '', to = ''] = window.split(':');
        const start = from ? dayFrom(from) : null;
        const end = to ? dayFrom(to) : null;
        if (start !== null && at < start) return false;
        if (end !== null && at >= end + DAY_MS) return false;
        return true;
    }

    const today = startOfDay(now);
    if (window === 'today') return at >= today && at < today + DAY_MS;
    if (window === 'week') {
        const weekday = (new Date(today).getDay() + 6) % 7;
        return at >= today - weekday * DAY_MS && at <= now.getTime();
    }
    if (window === 'month') return at >= new Date(now.getFullYear(), now.getMonth(), 1).getTime() && at <= now.getTime();

    const days = ROLLING[window];
    if (!days) return true;
    return now.getTime() - at <= days * DAY_MS && at <= now.getTime() + DAY_MS;
}

export default dateWindowMatch;
